import React from 'react';
import s from './PrivacyPolicy.module.css';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className={s.privacy_policy}>
            <h1>Privacy Policy</h1>
            <p>
                <strong>Last Updated: November 28th, 2024</strong>
            </p>
            <p>
                Protecting and respecting the privacy of your personal information is of the utmost
                importance to AIO Inc. (“<strong>AIO</strong>”, “<strong>we</strong>”, “
                <strong>us</strong>
                ”, “<strong>our</strong>”).
            </p>
            <p>
                This Privacy Policy describes how we collect, use, and share your information when
                you use our website located at simpleecreate.com, our mobile applications, and other
                services we may offer (collectively, the “<strong>Services</strong>”). This Privacy
                Policy also explains how we use cookies and similar technologies. By using the
                Services, you agree to be bound by the terms and conditions of this Privacy Policy.
            </p>
            <p>
                We may change our Privacy Policy from time to time. If we make changes, we will
                notify you by posting the updated Privacy Policy and revising the “Last Updated”
                date above. We encourage you to review this Privacy Policy frequently to stay
                informed about our privacy practices. By continuing to use the Services after the
                changes are made, you agree to be bound by the revised Privacy Policy.
            </p>

            <h2>Information Collection:</h2>
            <p>
                We collect personal information that you voluntarily provide to us through our
                Services or through other means. This includes, but is not limited to, your name,
                address, email address, telephone number, image, and credit card details when you
                pay for our services. We also collect information about your interaction with the
                Services and other users. If you choose to log into the Services using OAuth
                authentication, we will have access to information in your account, as disclosed to
                you when you grant us permission to authenticate you using your third-party account.
            </p>
            <p>
                We may also collect additional personal information from you or from public sources
                in order to verify your contact information.
            </p>

            <h2>Cookies and Interest-Based Advertising:</h2>
            <p>
                We may use cookies (small text files) and other technologies for authentication,
                analytics, performance, functional, and marketing purposes. We may also use
                third-party service providers, such as Google Analytics, which use cookies or other
                technologies to record information about you or your activity. You may modify your
                browser’s settings to prevent it from accepting cookies or to prompt you before
                accepting a cookie. We or our third-party advertising providers may use cookies and
                small pixel files (small images) to keep track of your browser, so that you will be
                recognized when you visit other websites where our third-party advertising providers
                may show you advertisements from us based on your visit to our Services.
            </p>
            <p>
                Some of these advertisements may be customized to particular products and services
                that you viewed, or they may be based on inferences about products and services that
                you might be interested in. This is called "interest-based advertising." You can opt
                out of these interest-based advertising campaigns by turning off cookies in your
                browser, as described above. If you opt-out, you may still see advertisements from
                us on other websites, but they will not be customized based on your browsing history
                on our Service.
            </p>

            <h2>Information Use:</h2>
            <p>
                We use your personal information to provide products and services and to manage our
                business operations. For example, we may use your personal information to:
            </p>
            <ul>
                <li>register your account</li>
                <li>authenticate you when you log in</li>
                <li>process payments for services offered by us</li>
                <li>provide customer support and resolve disputes</li>
                <li>improve our Services and develop new features</li>
                <li>send you promotional communications and advertisements</li>
                <li>analyze user behavior and preferences</li>
            </ul>

            <h2>How do we share your information:</h2>
            <p>We may share your information as follows:</p>
            <ul>
                <li>
                    With third-party service providers who help us with our business operations. For
                    example, we share information with service providers who provide us with
                    development, storage, marketing, promotional, analytics and payment processing
                    services. Whenever we hire other organizations to provide support services, they
                    will be required to conform to our privacy standards. These third parties shall
                    use the personal information only for purposes related to the supply of services
                    to us and they will also respect strict contractual conditions that oblige them
                    to maintain the confidentiality of all information.
                </li>
                <li>
                    If we are involved in a merger, acquisition, or sale of all or a portion of our
                    assets, we may transfer your personal information as part of that transaction.
                </li>
                <li>
                    We may also share aggregated demographic or otherwise non-personal information
                    with our partners and advertisers (who advertise on our Services), such as usage
                    statistics of the Service.
                </li>
                <li>
                    To fulfill the purpose for which you provided the information or for any other
                    purpose disclosed by us when you provide the information.
                </li>
                <li>With your consent.</li>
            </ul>
            <p>
                Sharing of Information We may share your personal information with our affiliates,
                service providers and partners, including but not limited to Stripe, Inc. (“
                <strong>Stripe</strong>
                ”).We only share information that is necessary for them to provide the services to
                us or to you. We also share information with third-party service providers to
                perform functions such as data analysis, payment processing, hosting services and
                email management. These third parties are only authorized to use your information in
                connection with the specific services they provide to us and are required to
                maintain the confidentiality of your information.
            </p>
            <p>
                We may also share your personal information as required or permitted by law or as
                necessary to protect our rights and the rights of others. This includes sharing
                information with law enforcement or other government agencies or to respond to a
                subpoena or court order.
            </p>

            <h2>International Transfer of Information:</h2>
            <p>
                e are based in the United States and the information we collect is governed by
                United States law. If you are located outside of the United States, please be aware
                that information we collect, including personal information, may be transferred to,
                processed and stored in the United States. By using the Services, or providing us
                with any information, you consent to this transfer, processing and storage of your
                information in the United States. Residents of the European Union
            </p>
            <p>
                This section applies only to natural persons (a “European Resident”) residing in the
                European Economic Area (the “EEA”). It is AIO’s policy to comply with the EEA's
                General Data Protection Regulation (the “GDPR”).  If you are a European resident,
                you have the right to access personal information we hold about you and to ask that
                your personal information be corrected, updated, or deleted. If you would like to
                exercise this right, please contact us through the contact information below.
            </p>
            <p>
                Additionally, if you are a European resident we note that we are processing your
                information in order to pursue our legitimate business interests listed above. 
                Additionally, please note that your information will be transferred outside of
                Europe, including Canada and the United States.
            </p>
            <h2>Accessing, Modifying and Deleting Your Personal Information:</h2>
            <p>
                You have the right to access, modify and delete your personal information that we
                have collected through the Services. You can make changes to your personal
                information by logging into your account and updating your profile. If you would
                like to delete your account, you can send us an email at
                <a href="mailto:support@simpleecreate.com" className={s.email_link}>
                    {' '}
                    support@simpleecreate.com
                </a>{' '}
                and we will delete your personal information in accordance with our data retention
                policy.
            </p>

            <h2>Children and Minors</h2>
            <p>
                The Service is not directed to children under the age of 13 years. We will not
                knowingly collect personal information about a child under the age of 13 and we do
                not allow minors (persons who are under the age of majority in their place of
                residence) to create accounts, make purchases or enter contests or promotions.
            </p>

            <h2>Security:</h2>
            <p>
                We will take reasonable steps to protect personal information from unauthorized
                access, use or disclosure. We protect the personal information within our custody or
                control with appropriate organizational, technological and physical safeguards.
                Reasonable steps include measures appropriate to the level of sensitivity of the
                personal information. For instance, our website and mobile applications are
                encrypted using SSL technology. However, no method of electronic transmission or
                Service is 100% secure and we cannot guarantee that unauthorized access, hacking,
                data loss or breaches of our security systems will never occur. Accordingly, you
                should not transmit personal information to us using our Services if you consider
                that information to be sensitive.
            </p>
            <p>
                We only retain personal information for as long as is necessary for the purpose for
                which it was collected. When we no longer are required to retain the information, we
                will destroy, erase, or de-identify the information. Legal requirements, however,
                may require us to retain some or all of the personal information we hold for a
                period of time that is longer than that for which we might otherwise hold it.
            </p>

            <h2>Contact Us:</h2>
            <p>
                If you have any questions about this Privacy Policy or the information we collect
                about you, please contact us by email at{' '}
                <a href="mailto:support@simpleecreate.com" className={s.email_link}>
                    support@simpleecreate.com
                </a>
                .
            </p>

            <h2>Updating the Privacy Policy</h2>
            <p>
                The privacy policy was last updated on November 28th, 2024. We may change our
                Privacy Policy from time to time and will notify you of any changes by posting the
                updated Privacy Policy on this page and revising the "Last Updated" date above. We
                encourage you to review this Privacy Policy frequently to stay informed about our
                privacy practices. By continuing to use the Services after the changes are made, you
                agree to be bound by the revised Privacy Policy.
            </p>

            <h2>New and More Strict Rules:</h2>
            <ul>
                <li>
                    <strong>Increased Data Encryption:</strong> To ensure the highest level of
                    protection of user data, AIO will increase the use of encryption methods for all
                    data storage and transmission.
                </li>
                <li>
                    <strong>Strict Access Controls:</strong> Access to user data will be restricted
                    only to authorized personnel who require it for performing their job duties, and
                    all access attempts will be logged and monitored for suspicious activity.
                </li>
                <li>
                    <strong>Third-Party Data Sharing Restrictions:</strong> AIO will carefully
                    review and restrict the sharing of user data with third-party service providers,
                    unless it is necessary to provide the services to users. Service providers will
                    be required to maintain the confidentiality of user data and implement
                    appropriate security measures.
                </li>
                <li style={{ marginBottom: 50 }}>
                    <strong>Data Retention Policy:</strong> AIO will establish a clear data
                    retention policy that outlines the length of time user data will be kept, and
                    the circumstances under which it will be deleted. This policy will be
                    transparent and communicated to users.
                </li>
            </ul>
        </div>
    );
};

export default PrivacyPolicy;
